import i18n from 'app-i18n';
import { isDateRangeValid } from 'components/forms/fields/date-range-field/date-range-field.utils';
import * as yup from 'yup';

export const setClosedDatesFormSchema = yup.object().shape({
  dateRange: yup
    .array()
    .required()
    .test(
      'validDateRange',
      () =>
        i18n.t(
          'forms.setClosedDatesForm.fields.dateRange.errors.invalidTimeRange',
        ),
      isDateRangeValid,
    ),
  pickupClosed: yup.bool().default(false),
  deliveryClosed: yup.bool().default(false),
});
